export const ROUTES = {
  PUBLIC: {
    LOGIN: '/auth/login',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    COMPLETE_INVITE: '/auth/complete-invite',
    AUTH_ERROR: '/auth/error',
  },

  ADMIN: {
    DASHBOARD: '/admin',
    USERS: '/admin/users',
    PROFILE: '/admin/profile',
    AUDIT: '/admin/audit',
    PARTNERS: '/admin/partners',
    INTEGRATIONS: '/admin/integrations',
    MERCHANTS: '/merchants',
  },

  PARTNER: {
    DASHBOARD: '/dashboard',
    TRANSACTIONS: '/transactions',
    PAYERS: '/payers',
    PAYER_DETAIL: '/payers/:payerId',
    PAYOUTS: '/payouts',
    INTEGRATIONS: '/integrations',
    NOTIFICATIONS: '/notifications',
    DOCUMENTATION: '/documentation',
    USERS: '/users',
    REPORT: '/report',
    DAILY_REPORTS: '/daily-reports',
    API_KEYS: '/api-keys',
    API_KEYS_CREATE: '/api-keys/create',
    API_KEYS_EDIT: '/api-keys/edit/:apiKeyId',
    WEBHOOKS: '/webhooks',
    WEBHOOK_MONITORING: '/webhooks/monitoring',
    WEBHOOK_MONITORING_DELIVERIES: '/webhooks/monitoring/deliveries',
    WEBHOOK_MONITORING_DELIVERY_DETAILS: '/webhooks/monitoring/deliveries/:deliveryId',
    WEBHOOK_MONITORING_ANALYTICS: '/webhooks/monitoring/analytics',
    WEBHOOK_MONITORING_WEBHOOK_SPECIFIC: '/webhooks/monitoring/webhook/:webhookId',
    PROFILE: '/profile',
    FEE_SCHEDULES: '/fee-schedules',
    FEE_SCHEDULE_MERCHANT_DETAIL: '/fee-schedules/merchants/:merchantId',
  },

  APP: {
    WIDGETS: '/widgets',
    USER_INFO: '/user-info',
    TOTP_ENROLLMENT: '/totp-enrollment',
  },
} as const
